export const ImageAndNameStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '50vh',
    gap: '5px',
    borderRadius: '10px',
    padding: '10px',
    marginTop: '10px',
    backgroundColor: '#14A06F'
}
export const ImageStyle = {
    width: '100px'
}
export const type = {
    display: 'flex',
    gap: '5px'
}
export const chips = {
    background: 'green',
    borderRadius: '5px',
    padding: '5px',
    color: 'white'
}